export default __webpack_public_path__ + "static/media/ttrevisionWhite.b0e43240.svg";